import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Alert, Spinner, Card, Row, Col, ButtonGroup, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DataManager } from '../../core/data-manager';
import { ResourceManager } from '../../core/resource-manager';
import { LanguageProvider } from '../../core/language-provider';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import blogDefault from '../../assets/course.jpg';


export default function Blog() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const { p } = useParams();
    const page = parseInt(p)

    const [data, setData] = useState(null);
    const [totalPages, setTotalPages] = useState(0);


    useEffect(() => {
        init()
    }, [page]);

    
    async function init() {
        var constraints = [
            {
                "fieldName": "public",
                "type": "value",
                "value": 1
            }
        ]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.searchItems('blog', page, 30, sorting, '', [], constraints)
        console.warn(response)
        if(response.success === 1) {
            setData(response.body)
            setTotalPages(response.pages)
        }
        else {
            setErrors('Errore. Riprova più tardi.')
        }
    }

    function changePage(p) {
        navigate('/blog/' + p)
    }

    function goToPrevPage() {
        if(page > 1) {
            changePage(page-1)
        }
    }
    function goToNextPage() {
        if(page < totalPages) {
            changePage(page+1)
        }
    }
    function goToFirstPage() {
        if(page !== 1) {
            changePage(1)
        }
    }
    function goToLastPage() {
        if(page !== totalPages) {
            changePage(totalPages)
        }
    }

    function openEntry(item) {
        navigate('/entry/' + item.id)
    }


    if (data !== null) {
        return (
            <>
                <Helmet>
                    <title>{'Blog - ' + page}</title>
                </Helmet>

                <Container fluid='md' className='mt-5 mb-5 text-center'>
                    <h3 className='text-secondary'>{LanguageProvider.get('header.blog')}</h3>

                    <Row className='mt-5 mb-5'>
                        {data.map((item, i) => {
                            var image = item.image ? ResourceManager.getFileUrl(item.image, 'blog') : blogDefault
                            return(
                                <Col key={i} xs={12} md={6} lg={4} className='mb-4'>
                                    <Card onClick={() => openEntry(item)} role='button' className='border-0 text-start bg-dark text-secondary'>
                                        <Card.Img src={image} />
                                        <Card.Body>
                                            <Card.Title>
                                                {item.title}
                                            </Card.Title>
                                            <Card.Text className='small'>{item.date && moment(item.date).format('DD/MM/YYYY HH:mm')}</Card.Text>
                                        </Card.Body>
                                    </Card>
                                    
                                </Col>
                            )
                        })}
                    </Row>
                    
                    <Container fluid className='text-center justify-content-center align-items-center d-flex'>
                        <ButtonGroup aria-label="blog pagination">
                            <Button variant="secondary" className={page === 1 ? 'disabled' : ''} onClick={goToFirstPage}><FontAwesomeIcon icon={'angles-left'} size={'lg'} /></Button>
                            <Button variant="secondary" className={page <= 1 ? 'disabled' : ''} onClick={goToPrevPage}><FontAwesomeIcon icon={'angle-left'} size={'lg'} /></Button>
                            <Button variant="secondary">{page}</Button>
                            <Button variant="secondary" className={page >= totalPages ? 'disabled' : ''} onClick={goToNextPage}><FontAwesomeIcon icon={'angle-right'} size={'lg'} /></Button>
                            <Button variant="secondary" className={page >= totalPages ? 'disabled' : ''} onClick={goToLastPage}><FontAwesomeIcon icon={'angles-right'} size={'lg'} /></Button>
                        </ButtonGroup>
                    </Container>

                </Container>
            </>
        )
    }
    else {
        return (
            <Container fluid='md' className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="secondary" />
                    <p className='text-secondary'>Loading</p>
                </div>
            </Container>
        )
    }
};